import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c854767"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clubList" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "display-2 mb-4",
  style: {"text-align":"center"}
}, "Klubber", -1))
const _hoisted_3 = { class: "searchcontrols row align--center justify--center" }
const _hoisted_4 = { class: "md2 flex ml-4 mobile" }
const _hoisted_5 = {
  class: "md5 flex",
  style: {"display":"flex"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "va-table-responsive" }
const _hoisted_9 = { class: "va-table va-table--clickable va-table--hoverable clubTable" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Kørestolsvenlig", -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "center" }
const _hoisted_13 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_15 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_16 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_18 = { class: "selectPageSize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_GoogleMaps = _resolveComponent("GoogleMaps")!
  const _component_va_select = _resolveComponent("va-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_va_button, {
          class: "btn",
          color: "#b4003a",
          rounded: false,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.columnSort('reset')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_va_icon, {
              class: "reset",
              name: "autorenew"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_va_input, {
          modelValue: _ctx.clubSearchInputValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.clubSearchInputValue) = $event)),
          label: "Søg",
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.findClub()), ["enter"])),
          style: {"width":"85%"}
        }, {
          prependInner: _withCtx(() => [
            _createVNode(_component_va_icon, { name: "travel_explore" })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_button, {
          class: "btn ml-2",
          color: "#b4003a",
          rounded: false,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.findClub()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_va_icon, { name: "search" }),
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_it_divider),
    (_ctx.clubLocationInfo.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_GoogleMaps, {
            locationInfo: _ctx.clubLocationInfo,
            locationSearchQuery: _ctx.clubSearchTerm,
            isMapReset: _ctx.isResetSearch
          }, null, 8, ["locationInfo", "locationSearchQuery", "isMapReset"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_it_divider),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("table", _hoisted_9, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              class: "sorting",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.columnSort('klubnavn')))
            }, "Klubnavn"),
            _createElementVNode("th", {
              class: "sorting",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.columnSort('klubby')))
            }, "By"),
            _hoisted_10
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.klubbers, (klub, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              onClick: ($event: any) => (_ctx.toClubInfo(klub.klubber_slug))
            }, [
              _createElementVNode("td", null, _toDisplayString(klub.klubber_klubnavn), 1),
              _createElementVNode("td", null, _toDisplayString(klub?.bypost_id?.bypost_by), 1),
              _createElementVNode("td", _hoisted_12, _toDisplayString(klub.klubber_koerestolsvenlig), 1)
            ], 8, _hoisted_11))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_va_button, {
        icon: "first_page",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.jumpToPage(1)))
      }),
      _createVNode(_component_va_button, {
        icon: "keyboard_double_arrow_left",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.turnToNewPage(-5)))
      }),
      _createVNode(_component_va_button, {
        icon: "chevron_left",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.turnToNewPage(-1)))
      }),
      _hoisted_14,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentPage) = $event)),
        type: "number",
        onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentPage)), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.currentPage]
      ]),
      (_ctx.totalNumberOfPages === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_15, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_16, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
      _createVNode(_component_va_button, {
        icon: "chevron_right",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.turnToNewPage(1)))
      }),
      _createVNode(_component_va_button, {
        icon: "keyboard_double_arrow_right",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.turnToNewPage(5)))
      }),
      _createVNode(_component_va_button, {
        icon: "last_page",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.jumpToPage(_ctx.totalNumberOfPages)))
      }),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_va_select, {
          class: "mr-2",
          modelValue: _ctx.pageSizeValueString,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
          options: _ctx.pageSizeOptions,
          bordered: ""
        }, null, 8, ["modelValue", "options"])
      ])
    ])
  ]))
}